/*
 * ------------------------------------------------------------------
 * Cofá – döljer "Save for later"-rutan (v1)
 *
 * Wishlist-appen visar en ruta när kunden tar bort en vara ur
 * varukorgen: "Save for later – Do you want to save this item for
 * later?". Funktionen är avstängd i appens inställningar men rutan
 * dyker upp ändå.
 *
 * Vi kan inte hårdkoda appens klassnamn – de kan ändras vid varje
 * appuppdatering. I stället känner koden igen rutan på TEXTEN och
 * klickar på appens egen "No, thanks"-knapp. Då städar appen upp
 * efter sig själv (bakgrund, scroll-lås) precis som om kunden hade
 * klickat. Rutan göms samtidigt med CSS så den aldrig hinner synas.
 *
 * Vill du fånga fler formuleringar: lägg till dem i PHRASES nedan,
 * i gemener. Vill du stänga av allt: ta bort raden
 * {% render 'cofa-hide-save-for-later' %} ur
 * sections/cofa-gift-embed.liquid.
 * ------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* Texter som identifierar rutan. Håll dem specifika – en för kort
     fras riskerar att träffa vanliga knappar på sidan. */
  var PHRASES = [
    'do you want to save this item for later',
    'vill du spara den här varan till senare',
    'vill du spara denna vara till senare'
  ];

  /* Knappar som betyder "nej". Appen städar upp när någon av dem klickas. */
  var DISMISS = [
    'no, thanks',
    'no thanks',
    'nej tack',
    'nej, tack',
    'cancel',
    'avbryt',
    'لا شكرا',
    'لا، شكرًا'
  ];

  function norm(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function matches(text) {
    for (var i = 0; i < PHRASES.length; i++) {
      if (text.indexOf(PHRASES[i]) > -1) return true;
    }
    return false;
  }

  /* Går nedåt till det minsta elementet som fortfarande innehåller hela
     frasen – alltså själva rutan, inte hela sidan. */
  function findPanel(root) {
    if (!root || root.nodeType !== 1) return null;
    if (!matches(norm(root.textContent))) return null;

    var node = root;
    var guard = 0;

    while (guard++ < 25) {
      var next = null;
      for (var i = 0; i < node.children.length; i++) {
        if (matches(norm(node.children[i].textContent))) {
          next = node.children[i];
          break;
        }
      }
      if (!next) break;
      node = next;
    }

    return node;
  }

  /* Yttersta positionerade behållaren – appens overlay inklusive bakgrund. */
  function overlayOf(element) {
    var best = element;
    var node = element;
    var guard = 0;

    while (node && node !== document.body && guard++ < 12) {
      var position = window.getComputedStyle(node).position;
      if (position === 'fixed' || position === 'absolute') best = node;
      node = node.parentElement;
    }

    return best;
  }

  function dismissButton(container) {
    var candidates = container.querySelectorAll('button, a, [role="button"]');
    var i;

    for (i = 0; i < candidates.length; i++) {
      if (DISMISS.indexOf(norm(candidates[i].textContent)) > -1) return candidates[i];
    }

    for (i = 0; i < candidates.length; i++) {
      var label = norm(candidates[i].getAttribute('aria-label'));
      if (label.indexOf('close') > -1 || label.indexOf('stäng') > -1) return candidates[i];
    }

    return null;
  }

  /* Rör aldrig scroll-låset om temats egen drawer eller popup är öppen. */
  function otherOverlayOpen() {
    return !!(
      document.querySelector('dialog[open]') ||
      document.querySelector('cart-drawer.active') ||
      document.querySelector('cart-notification.active')
    );
  }

  function handle(node) {
    var panel = findPanel(node);
    if (!panel) return false;

    var overlay = overlayOf(panel);
    if (!overlay || overlay === document.body || overlay === document.documentElement) {
      overlay = panel;
    }

    /* Göm först, fråga sen – kunden ska aldrig se rutan blinka förbi. */
    overlay.setAttribute('data-cofa-hidden', '');

    var button = dismissButton(overlay) || dismissButton(panel);
    if (button) {
      try {
        button.click();
      } catch (e) {
        /* Appen kan ha bytt ut knappen – vi städar i fallbacken nedan. */
      }
    }

    /* Fallback om appen inte städar upp efter sig. */
    window.setTimeout(function () {
      if (!overlay.isConnected) return;
      overlay.remove();

      if (otherOverlayOpen()) return;
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
      if (document.documentElement.style.overflow === 'hidden') {
        document.documentElement.style.overflow = '';
      }
      document.body.classList.remove('overflow-hidden');
    }, 500);

    return true;
  }

  function sweep() {
    handle(document.body);
  }

  /* Rutan dyker upp strax efter att en rad tagits bort – kolla några
     gånger i stället för att polla hela tiden. */
  function scheduleSweeps() {
    [60, 250, 600, 1200, 2000].forEach(function (delay) {
      window.setTimeout(sweep, delay);
    });
  }

  function boot() {
    sweep();

    /* Nya element som läggs till i DOM:en granskas direkt – oftast innan
       webbläsaren hinner måla ut rutan. */
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1 && handle(added[j])) return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* Om appen i stället visar en ruta som redan låg dold i sidan fångar
       vi den via varukorgshändelserna. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSweeps);
    }

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (target.closest('cart-drawer, #CartDrawer, cart-items, cart-drawer-items, .cart-item')) {
          scheduleSweeps();
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
